"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeEmail = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changeEmail = exports.changeEmail = (0, _actionGenerator.actionGenerator)(_types.ESocialsActionTypes.EmailChanged);